import { SlideModalType } from "@/component/common/report/reportConfigModel"


export enum PostMessageType {
  reportConfig = 'reportConfig',
  navigate = 'navigate',
  openSlideModal = 'openSlideModal',
  openDifyAI = 'openDifyAI'
}

type PostMessageTypeNavigate = {
  type: PostMessageType.navigate,
  data:{
    url:string,
    name: string  //tab标签名字
  }
}

type PostMessageTypeReportConfig = {
  type: PostMessageType.reportConfig,
  data: any
}

type PostMessageTypeSlideModal = {
  type: PostMessageType.openSlideModal,
  data: {
    modalType: SlideModalType,
    params: Record<string,any>
  }
}

type PostMessageTypeDifyAI = {
  type: PostMessageType.openDifyAI,
  data: {
    report: string,  // 当前报表
    searchParams: Record<string, any>,  // 搜索参数
    searchApiParams: Record<string, any>, // 后端Api使用的参数
    isInitSearch: boolean, // 是否是初始化搜索
    url: string, // 打开的url
  }
}

type PostMessageToParentOptions = PostMessageTypeReportConfig | PostMessageTypeNavigate | PostMessageTypeSlideModal | PostMessageTypeDifyAI



export const postMessageToParent = (options:PostMessageToParentOptions)=>{
  const { type,data } = options
  window.parent.postMessage({ type: type, data:data }, '*');
}